module.exports = __webpack_public_path__ + "img/sec_openTime.9ae9dc2e.svg";